<template>
  <transition name="el-zoom-in-center">
    <el-card class="box-card" style="text-align: left;" v-show="add.addshow">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" style="width:100%" :rules="rules">
        <el-row style="margin:10px 0 30px 0;">
          <el-col :span="15" :offset="9">
            <div class="demo-image__preview">
              <div style="float:left">
                <span
                  class="demonstration"
                  style="display:block;text-align:center;width:100px;margin:5px 0;"
                >通用版</span>
                <el-image
                  style="width: 100px; height: 230px;margin-right:30px;"
                  :src="url1"
                  :preview-src-list="srcList1"
                ></el-image>
              </div>
              <div style="float:left">
                <span
                  class="demonstration"
                  style="display:block;text-align:center;width:100px;margin:5px 0;"
                >简易版</span>
                <el-image
                  style="width: 100px; height: 230px;margin-right:30px;"
                  :src="url2"
                  :preview-src-list="srcList2"
                ></el-image>
              </div>
              <div style="float:left">
                <span
                  class="demonstration"
                  style="display:block;text-align:center;width:100px;margin:5px 0;"
                >定制版</span>
                <el-image
                  style="width: 100px; height: 230px;margin-right:30px;"
                  :src="url3"
                  :preview-src-list="srcList3"
                ></el-image>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="模板" prop="templateId">
              <el-select v-model="form.templateId" placeholder="请选择模板" style="width:100%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="追溯信息">
              <el-checkbox-group v-model="checkedCities" @change="item">
                <el-checkbox v-for="(item,i) in cities" :label="item.value" :key="i">{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>模板</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form
                ref="productform"
                :model="productform"
                label-width="140px"
                style="width:80%"
                :rules="rules"
              >
                <el-form-item label="元素" prop="templateOrder">
                  <el-select
                    v-model="productform.templateOrder"
                    placeholder="请选择元素"
                    style="width:70%"
                    v-show="form.templateId == 1"
                  >
                    <el-option
                      v-for="item in theelement1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="productform.templateOrder"
                    placeholder="请选择元素"
                    style="width:70%"
                    v-show="form.templateId == 2"
                  >
                    <el-option
                      v-for="item in theelement2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="productform.templateOrder"
                    placeholder="请选择元素"
                    style="width:70%"
                    v-show="form.templateId == 3"
                  >
                    <el-option
                      v-for="item in theelement3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                  <el-select v-model="productform.type" placeholder="请选择类型" style="width:70%">
                    <el-option
                      v-for="item in type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="内容" v-show="productform.type == 1" prop="content">
                  <el-input
                    v-model="productform.content"
                    style="width:70%"
                    type="textarea"
                    autosize
                  ></el-input>
                </el-form-item>
                <el-form-item label="图片上传" v-show="productform.type == 2 || productform.type == 3">
                  <el-upload
                    ref="upload"
                    :action="uploadurl"
                    list-type="picture-card"
                    :on-success="qinchulist"
                    :on-preview="handlePictureCardPreview"
                    :before-upload="beforeAvatarUpload"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :file-list="fileList"
                    :limit="1"
                    :on-change="onchange"
                    name="pic"
                  >
                    <el-tooltip class="item" effect="dark" content="只能上传1张图片" placement="top">
                      <i class="el-icon-plus"></i>
                    </el-tooltip>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="图片展开" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="链接" prop="link">
                  <el-input v-model="productform.link" style="width:70%"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('productform')">重置</el-button>
                <el-button
                  style="margin-top: 12px;"
                  type="primary"
                  @click="productadd('productform')"
                >生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right"></el-button>
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="newList" stripe style="width: 100%" height="224">
                <el-table-column prop="templateOrder" label="排序" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="内容" min-width="100"></el-table-column>
                <el-table-column prop="address" label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        type="danger"
                        @click.native.prevent="deleteRow(scope.$index, tablelist)"
                      >删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
const Options = [
  { label: "产品名称", value: "product_name:true" },
  { label: "追溯数码", value: "qrcode:true" },
  { label: "首次扫码", value: "create_time:true" },
  { label: "扫码次数", value: "count:true" },
  { label: "生产厂商", value: "enterpriseName:true" },
  { label: "生产批次", value: "batchNo:true" }
];
import { insertcontent, insertcontentpics } from "@/api/qrcode";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      options: [
        {
          value: 1,
          label: "通用模板"
        },
        {
          value: 2,
          label: "简易模板"
        },
        {
          value: 3,
          label: "定制模板"
        }
      ],
      type: [
        {
          value: 1,
          label: "文字"
        },
        {
          value: 2,
          label: "图片"
        },
        {
          value: 3,
          label: "轮播图"
        }
      ],
      theelement1: [
        {
          value: 1,
          label: "轮播图"
        },
        {
          value: 2,
          label: "元素1"
        },
        {
          value: 3,
          label: "元素2"
        }
      ],
      theelement2: [
        {
          value: 1,
          label: "轮播图"
        },
        {
          value: 2,
          label: "元素1"
        }
      ],
      theelement3: [
        {
          value: 1,
          label: "轮播图"
        },
        {
          value: 2,
          label: "元素1"
        },
        {
          value: 3,
          label: "元素2"
        },
        {
          value: 4,
          label: "元素3"
        },
        {
          value: 5,
          label: "元素4"
        },
        {
          value: 6,
          label: "元素5"
        },
        {
          value: 7,
          label: "元素6"
        }
      ],
      url1: require("@/assets/css/img/通用版.webp"),
      url2: require("@/assets/css/img/简易版.webp"),
      url3: require("@/assets/css/img/定制版.webp"),
      srcList1: [require("@/assets/css/img/通用版.webp")],
      srcList2: [require("@/assets/css/img/简易版.webp")],
      srcList3: [require("@/assets/css/img/定制版.webp")],
      checkedCities: [],
      cities: Options,
      show: true,
      form: {
        templateId: 1
      },
      productform: {
        content: "",
        enable: 1,
        link: "",
        templateId: null,
        type: 1,
        templateOrder: null
      },
      informationform: {
        content: "",
        enable: 1,
        link: "",
        templateId: null,
        type: 4,
        templateOrder: null
      },
      // 步骤2表格数据
      tablelist: [],
      rules: {
        templateOrder: [
          { required: true, message: "请选择元素", trigger: "blur" }
        ],
        templateId: [
          { required: true, message: "请选择模板类型", trigger: "blur" }
        ],
        type: [{ required: true, message: "请选择内容类型", trigger: "blur" }]
      },
      uploadurl:
        process.env.VUE_APP_BASE_API_baseinfo +
        "/api/out/qrcodescantemplate/insertcontentpic",
      ifFile: false,
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      information: null
    };
  },
  computed: {
    newList() {
      function compare(prop) {
        return function(a, b) {
          let v1 = a[prop];
          let v2 = b[prop];
          return v1 - v2; //从小到大排序
        };
      }
      return this.tablelist.sort(compare("templateOrder"));
    }
  },
  mounted() {},
  methods: {
    item() {
      this.informationform.content = this.checkedCities.join();
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ifFile) {
            this.uploadurl =
              process.env.VUE_APP_BASE_API_baseinfo +
              "/api/out/qrcodescantemplate/insertcontentpic";
            this.$refs.upload.submit();
          } else {
            const obj = {};
            obj["type"] = this.productform.type;
            obj["enable"] = this.productform.enable;
            obj["templateId"] = this.form.templateId;
            obj["content"] = this.productform.content;
            obj["link"] = this.productform.link;
            obj["templateOrder"] = this.productform.templateOrder;

            // for (let i = 0; i < this.tablelist.length; i++) {
            //   // 产品不能重复
            //   if (
            //     this.tablelist[i].templateOrder ==
            //     this.productform.templateOrder
            //   ) {
            //     this.$message({
            //       type: "warning",
            //       message: "不能重复!"
            //     });
            //     return;
            //   }
            // }
            this.tablelist.push(obj);
            // console.log(this.tablelist);
            this.$refs[formName].resetFields();
            this.productform.link = "";
            this.productform.content = "";
            this.$refs.upload.clearFiles();
          }
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    //保存提交
    submitadd(formName) {
      if (this.tablelist.length == 0) {
        this.$message({
          type: "warning",
          message: "请填写完整模板信息!"
        });
        return;
      }
      switch (this.tablelist[0].templateId) {
        case 1:
          if (this.tablelist.length < 3) {
            this.$message({
              type: "warning",
              message: "请填写完整模板信息!"
            });
            return;
          }
          break;
        case 2:
          if (this.tablelist.length < 2) {
            this.$message({
              type: "warning",
              message: "请填写完整模板信息!"
            });
            return;
          }
          break;
        case 3:
          if (this.tablelist.length < 7) {
            this.$message({
              type: "warning",
              message: "请填写完整模板信息!"
            });
            return;
          }
          break;
        default:
          break;
      }
      this.informationform.templateId = this.form.templateId;
      this.informationform.templateOrder = this.tablelist.length + 1;
      if (this.informationform.content !== "") {
        this.tablelist.push(this.informationform);
      } else {
        this.$message({
          type: "warning",
          message: "请勾选追溯信息!"
        });
        return;
      }
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          insertcontent(this.tablelist).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.search();
              this.tablelist = [];
              this.checkedCities = [];
              this.informationform.content = "";
              this.add.addshow = false;
              this.resetForm(formName);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onchange(file) {
      this.ifFile = !this.ifFile;
    },
    qinchulist(response, file, fileList) {
      this.productform.content = response.data;
      const obj = {};
      obj["type"] = this.productform.type;
      obj["enable"] = this.productform.enable;
      obj["templateId"] = this.form.templateId;
      obj["content"] = this.productform.content;
      obj["link"] = this.productform.link;
      obj["templateOrder"] = this.productform.templateOrder;

      // for (let i = 0; i < this.tablelist.length; i++) {
      //   // 产品不能重复
      //   if (this.tablelist[i].templateOrder == this.productform.templateOrder) {
      //     this.$message({
      //       type: "warning",
      //       message: "不能重复!"
      //     });
      //     return;
      //   }
      // }
      this.tablelist.push(obj);
      // console.log(this.tablelist);
      this.resetForm("productform");
      this.productform.link = "";
      this.productform.content = "";
      this.$refs.upload.clearFiles();
    },
    handleRemove(file, fileList) {
      this.ifFile = !this.ifFile;
      this.productform.content = "";
    },
    beforeAvatarUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isLt1M;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
